// extracted by mini-css-extract-plugin
export default {"modalOverlay":"styled_modalOverlay__UUSZO","modalContent":"styled_modalContent__iRcO6","modalBody":"styled_modalBody__DhUjR","modalClose":"styled_modalClose__r4e2T"};